module.exports = __webpack_public_path__ + "static/Denture 2 smile before-710c6d7a4abb572df8c9ba8012dfccc1.jpg";